import React, { useEffect } from 'react';
import { View, StyleSheet, Text, ScrollView } from 'react-native';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { useDispatch, useSelector } from 'react-redux';
import { getCleanUrl } from '../../utils/Helper';
import { ImageComp } from '../../components/Image/Image';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CHECK, KEY_ICON, SUCCESS_CHECK } from '../../assets';
import CustomPressable from '../../components/customPressable/customPressable';
import { makeLayoutApiCalls } from '../../js/fetchAppConfigs';
import { useNavigation } from '@react-navigation/native';
import { setGoHome } from '../../Redux/Reducers/appConfigReducer';
import { setProceedLoginToTheApp } from '../../Redux/Actions/appConfigAction';
import { useTranslation } from 'react-i18next';

const CheckInSuccess = ({ checkedInGuestDetails }) => {

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const navigation = useNavigation();

    const { doorKeyType } = useSelector((state) => state.appConfigSlice);

    const handleContinueMyStay = () => {
        dispatch(setGoHome(true));
    }


    useEffect(() => {

        return () => {
            dispatch(setProceedLoginToTheApp(true, { lastName: checkedInGuestDetails.lastName, confirmationNumber: checkedInGuestDetails.confirmationNumber, checkinDate: checkedInGuestDetails.checkinDate, roomNumber: checkedInGuestDetails.roomNumber, candoAccompanyLogin: false, candoOtpFlow: false }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    const renderHeader = () => {


        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'checkInSuccessHeaderContainer'])}>
                <View style={getStyles(['checkInSuccessContainerHeaderImgContainer'])}>
                    <View style={getStyles(['checkInSuccessContainerHeaderImgBackground'])}>
                        <ImageComp source={SUCCESS_CHECK} style={getStyles(['checkInSuccessContainerHeaderImg'])} />
                    </View>
                </View>
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'checkInSuccessHeaderTitleContainer'])}>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'checkInSuccessHeaderTitle'])}>{t('check_in.checkin_success.heading')}</Text>
                    {t('check_in.checkin_success.sub_heading') && <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'checkInSuccessHeaderSubTitle'])}>{t('check_in.checkin_success.sub_heading')}</Text>}
                </View>
            </View>
        )
    }


    return (
        <View style={getStyles(['widgetRootContainer', 'checkInSuccessRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleContinueMyStay} />

            <ScrollView contentContainerStyle={getStyles(['widgetmainContainer', 'checkInSuccessMainContainer'])} showsVerticalScrollIndicator={false}>
            {renderHeader()}

            <View style={getStyles(['widgetmainContainerChildContainer', 'checkInSuccessMainContainerChildContainer'])}>

                <View style={getStyles(['checkInSuccessMainContainerChildContainer_textContainer'])}>
                    <Text style={getStyles(['checkInSuccessMainContainerChildContainer_infotext'])}>{t('check_in.checkin_success.info_text')}
                        <Text style={getStyles(['checkInSuccessMainContainerChildContainer_infotext_roomnumber'])}>{checkedInGuestDetails.roomNumber}</Text> 
                    </Text>

                    <Text style={getStyles(['checkInSuccessMainContainerChildContainer_subinfotext'])}>
                        {doorKeyType && doorKeyType != "" ? (
                            <>
                            {t('check_in.digital_key_msg1')}
                            <ImageComp
                                source={KEY_ICON}
                                id='GenericDoorkeyImage'
                                style={getStyles(['autoLoginGenericDoorkeyImage'])}
                            />
                            {t('check_in.digital_key_msg2')}
                            </>
                            ) : (
                                t('check_in.key_from_desk')
                            )}
                    </Text>
                </View>

                <CustomPressable style={getStyles(['primaryBtn'])} onPress={handleContinueMyStay}>
                    <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.checkin_success.primary_button')}</Text>
                </CustomPressable>
            </View>
            </ScrollView>
        </View>
    );
};
export default CheckInSuccess;
